var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('UiAccessoriesList',{key:_vm.$route.fullPath,attrs:{"products":_vm.products,"filters":_vm.data.filters,"slug":(_vm.slug + "/"),"category":_vm.linkLabel}})}
var staticRenderFns = []

export { render, staticRenderFns }